import * as THREE from 'three';
import { WorkshopArt } from '../art/workshop';
export interface PlayerRobotHandles {
 group:THREE.Group;
 update:(dt:number,direction:-1|0|1,bounds:{minX:number;maxX:number})=>void;
 react:(kind:'scan'|'success'|'error')=>void;
 moveToX:(x:number)=>void;getPositionX:()=>number;setPositionX:(x:number)=>void;dispose:()=>void;
}
export function createPlayerRobot():PlayerRobotHandles {
 const group=new THREE.Group();group.position.z=2.6;group.scale.setScalar(.88);
 const art=new WorkshopArt(.14),body=new THREE.Group();body.position.x=-.45;group.add(body);
 const shell=0xeff5ff,navy=0x253b57,cyan=0x50dfff;
 art.material(shell).roughness=.3;art.material(navy).roughness=.4;
 art.material(cyan).emissive.setHex(cyan);art.material(cyan).emissiveIntensity=.65;
 art.box(body,navy,[.57,.61,.42],[0,.82,0]);art.box(body,shell,[.7,.58,.5],[0,.87,0]);
 art.box(body,navy,[.44,.27,.065],[0,.88,.28]);
 art.box(body,0xffba43,[.22,.065,.035],[0,.94,.32]);
 for(let i=0;i<3;i++)art.box(body,cyan,[.045,.05,.02],[-.1+i*.1,.83,.32]);
 art.box(body,navy,[.5,.12,.44],[0,.53,0]);
 // Backpack and neck give the silhouette depth when the robot turns.
 art.box(body,0x6c8cab,[.48,.43,.2],[0,.88,-.33]);art.sphere(body,navy,.16,[0,1.23,0]);
 const head=new THREE.Group();head.position.y=1.56;body.add(head);
 art.box(head,navy,[1.02,.79,.7],[0,0,-.035]);art.box(head,shell,[1.03,.77,.72],[0,.02,0]);
 art.box(head,navy,[.86,.54,.07],[0,0,.37]);art.box(head,0x101e32,[.75,.43,.025],[0,0,.415]);
 const eyes=[-.21,.21].map(x=>art.box(head,cyan,[.13,.22,.035],[x,.025,.44]));
 const mouth=art.box(head,0xffc253,[.15,.038,.025],[0,-.13,.44]);
 art.box(head,0xffffff,[.35,.035,.02],[-.13,.23,.412]);
 for(const x of [-.56,.56]){art.sphere(head,navy,.15,[x,0,0]);art.sphere(head,0xffba43,.09,[x*1.13,0,.03]);}
 art.box(head,navy,[.035,.2,.035],[.27,.49,0]);art.sphere(head,cyan,.065,[.27,.61,0]);
 const legs:THREE.Group[]=[],arms:THREE.Group[]=[];
 for(const side of [-1,1]){
  const leg=new THREE.Group();leg.position.set(side*.24,.49,0);body.add(leg);legs.push(leg);
  art.sphere(leg,navy,.13,[0,0,0]);art.box(leg,0x7591b4,[.21,.24,.22],[0,-.16,0]);
  art.box(leg,navy,[.34,.19,.48],[0,-.35,.09]);art.box(leg,shell,[.31,.12,.32],[0,-.29,.16]);
  const arm=new THREE.Group();arm.position.set(side*.46,1.05,0);body.add(arm);arms.push(arm);
  art.sphere(arm,navy,.14,[0,0,0]);art.box(arm,shell,[.24,.33,.27],[side*.025,-.2,.01]);
  art.sphere(arm,navy,.135,[side*.025,-.4,.06]);
 }
 // Wrist scanner: beam is transient and does not reveal hidden values.
 const scanner=art.box(arms[1]!,navy,[.2,.14,.22],[.025,-.36,.2]);
 art.box(scanner,cyan,[.13,.07,.025],[0,0,.12]);
 const beamGeometry=new THREE.ConeGeometry(.19,1.2,16,1,true);
 const beamMaterial=new THREE.MeshBasicMaterial({color:cyan,transparent:true,opacity:.15,depthWrite:false,side:THREE.DoubleSide});
 const beam=new THREE.Mesh(beamGeometry,beamMaterial);beam.rotation.x=-Math.PI/2;beam.position.set(.05,1.02,-.9);group.add(beam);beam.visible=false;
 let targetX=0,elapsed=0,reaction:'scan'|'success'|'error'='scan',remaining=0;
 return {group,react(kind){reaction=kind;remaining=kind==='success'?1.35:.65;},update(dt,direction,bounds){
  elapsed+=dt;if(direction)targetX=THREE.MathUtils.clamp(targetX+direction*3.8*dt,bounds.minX,bounds.maxX);
  const dx=targetX-group.position.x,moving=Math.abs(dx)>.025||direction!==0;
  group.position.x=THREE.MathUtils.damp(group.position.x,targetX,13,dt);
  remaining=Math.max(0,remaining-dt);const active=remaining>0;
  const success=active&&reaction==='success',scan=active&&reaction==='scan';
  const wave=Math.sin(elapsed*17);
  body.position.y=success?Math.abs(Math.sin(remaining*7))*.17:moving?Math.abs(wave)*.045:Math.sin(elapsed*2)*.015;
  body.rotation.y=THREE.MathUtils.damp(body.rotation.y,scan?-2.6:moving?Math.sign(dx)*.38:0,9,dt);
  head.rotation.z=active&&reaction==='error'?Math.sin(remaining*30)*.09:Math.sin(elapsed*1.6)*.025;
  head.rotation.x=THREE.MathUtils.damp(head.rotation.x,scan?.1:0,8,dt);
  legs.forEach((leg,i)=>leg.rotation.x=moving?Math.sin(elapsed*17+i*Math.PI)*.38:0);
  arms.forEach((arm,i)=>{arm.rotation.x=THREE.MathUtils.damp(arm.rotation.x,success?-2.2:scan&&i===1?-1.15:moving?-Math.sin(elapsed*17+i*Math.PI)*.3:0,12,dt);arm.rotation.z=success?(i?-.35:.35):0;});
  const blink=elapsed%4.6>4.43?.16:1;eyes.forEach(eye=>eye.scale.y=.22*(success?.7:blink));mouth.scale.x=success?.22:.15;
  beam.visible=scan;beamMaterial.opacity=.12+Math.sin(elapsed*32)*.04;
 },moveToX(x){targetX=x;},getPositionX:()=>group.position.x,setPositionX(x){targetX=x;group.position.x=x;remaining=0;},dispose(){beamGeometry.dispose();beamMaterial.dispose();art.dispose();}};
}
